import { useParams } from 'react-router-dom';
import ModuleContainer from '../containers/ModuleContainer';

export default function ModulePage() {
  const { platform, moduleName } = useParams() as { platform: string, moduleName: string };

  return (
    <ModuleContainer platform={platform} moduleName={moduleName} />
  );
}